import axios from "axios";
import OperationTypes from "../../types";

const VehicleMaintanenceService = {
  get: {
    vehicleByPlate: (tenant: string, plate: string) => {
      return axios
          .get<OperationTypes.Vehicle>(`masterdatavehicle/vehicle/plate/${plate}`, { params: { tenant: tenant } })
          .then((response) => response.data);
    },
  },
}

export default VehicleMaintanenceService;